export const apiUrl = './api/index.php/';
export const streamUrl = "./api/stream.php";
export const storeImgUrl = "./api/store-image.php";